import React from 'react';
import { ReactComponent as IconNetwork } from '@assets/icons/002-network.svg';
import Chats from './Chats/Chats';

const Icon = () => <IconNetwork alt="chats" />;

export default { list: Chats, icon: Icon };
